$(document).ready(function () {
    initSliders();
});

function getFeaturedSliderSettings(){
    return {
        nextArrow: $('.slider-next'),
        prevArrow: $('.slider-prev'),
        fade: true,
        speed: 0,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        lazyLoad: 'ondemand',
        asNavFor: '.pt-thumbnail-images-inner',
        arrows: true
    };
}

function getThumbnailSliderSettings(){
    return {
        dots: false,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        focusOnSelect: true,
        asNavFor: '.pt-featured-images-inner',
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    };
}


function initSliders() {
    $(".pt-featured-images-inner").not('.slick-initialized').slick(getFeaturedSliderSettings());
    $('.pt-thumbnail-images-inner').not('.slick-initialized').slick(getThumbnailSliderSettings());
}

function refreshSliders() {
    $('.pt-featured-images-inner').slick('refresh');
    $('.pt-thumbnail-images-inner').slick('refresh');
}

function destroySliders() {
    if($('.pt-featured-images-inner').hasClass('slick-initialized')) {
        $('.pt-featured-images-inner').slick('destroy');
        $('.pt-featured-images-inner').empty();
    }

    if($('.pt-thumbnail-images-inner').hasClass('slick-initialized')) {
        $('.pt-thumbnail-images-inner').slick('destroy');
        $('.pt-thumbnail-images-inner').empty();
    }
}